document.querySelectorAll('[data-filter]').forEach( filter => {

  const categories = {}
  const allItems = {}
  const urlParams = new URLSearchParams(window.location.search)
  let page = urlParams.get('seite') || 1
  const triggers = filter.querySelectorAll('[data-load-more-trigger]')
  let recentlyChanged = false

  let chipsContainer = document.querySelector('[data-filter-chips]')
  const categoryButtons = filter.querySelectorAll('[data-filter-category]')

  const forFamilyButtons = document.querySelectorAll('[data-filter-family]')
  let familyButtonsActive = urlParams.get('family') === '1'

  const resetButton = document.querySelector('[data-filter-reset]')

  categoryButtons.forEach( button => {
    const key = button.getAttribute('data-filter-category')

    const wrapper = filter.querySelector(`[data-filter-terms="${key}"]`)
    const itemElements = wrapper.querySelectorAll('[data-filter-value]')

    button.addEventListener('click', e => setCategoryActive(key))

    categories[key] = {
      button,
      wrapper,
      key,
      isOpen: false,
      hasActiveChild: false,
      items: {}
    }

    itemElements.forEach( itemEl => {
      const itemKey = itemEl.getAttribute('data-filter-value')
      categories[key].items[itemKey] = {
        element: itemEl,
        key: itemKey,
        isActive: urlParams.get(key) === itemKey,
        category: key
      }



      if (categories[key].items[itemKey].isActive) {
        categories[key].button.classList.add('has-active-child')
        categories[key].hasActiveChild = true

        categories[key].items[itemKey].element.classList.add('active')
      }

      allItems[`${key}::${itemKey}`] = categories[key].items[itemKey]

      itemEl.addEventListener('click', e => setItemActive(key, itemKey))
    })

  })


  forFamilyButtons.forEach( button => {
    if (familyButtonsActive) {
      button.classList.add('active')
    }
    button.addEventListener('click', e => {
      familyButtonsActive = !familyButtonsActive
      button.classList.toggle('active', familyButtonsActive)
      recentlyChanged = true
      updateUrl()
      updateChips()
    })
  })

  resetButton.addEventListener('click', e => {
    familyButtonsActive = false
    forFamilyButtons.forEach( button => button.classList.remove('active') )

    for (const key in categories) {
      categories[key].isOpen = false
      categories[key].wrapper.classList.remove('active')
      categories[key].button.classList.remove('active', 'has-active-child')
      for (const itemKey in categories[key].items) {
        categories[key].items[itemKey].isActive = false
        categories[key].items[itemKey].element.classList.remove('active')
      }
    }

    filter.classList.remove('any-category-open')

    recentlyChanged = true
    updateUrl()
    updateChips()
  })



  const setCategoryActive = (categoryKey, isOpen) => {
    let isAnyOpen = false
    for (const key in categories) {
      if (key === categoryKey) {
        categories[key].isOpen = !categories[key].isOpen
      } else {
        categories[key].isOpen = false
      }
      if (categories[key].isOpen) {
        isAnyOpen = true
      }
    }

    filter.classList.toggle('any-category-open', isAnyOpen)

    for (const key in categories) {
      if (categories[key].isOpen) {
        categories[key].wrapper.classList.add('active')
        categories[key].button.classList.add('active')
      } else {
        categories[key].wrapper.classList.remove('active')
        categories[key].button.classList.remove('active')
      }
    }
  }

  const setItemActive = (categoryKey, itemKey) => {
   for (const key in categories[categoryKey].items) {
     if (key === itemKey) {
       categories[categoryKey].items[key].isActive = !categories[categoryKey].items[key].isActive
     } else {
       categories[categoryKey].items[key].isActive = false
     }
     categories[categoryKey].items[key].element.classList.toggle('active', categories[categoryKey].items[key].isActive)
   }

   for(const key in categories) {
     let hasActive = false
     for (const itemKey in categories[key].items) {
       if (categories[key].items[itemKey].isActive) {
         hasActive = true
         break
       }
     }
     categories[key].hasActiveChild = hasActive
     categories[key].button.classList.toggle('has-active-child', hasActive)
   }

    recentlyChanged = true
    updateChips()
    updateUrl()
  }

  const createChip = text => {
    const chip = document.createElement('button')
    chip.classList.add('button', 'button-filter', 'button-filter-chip')
    chip.innerText = text
    const closeIcon = document.createElement('span')
    closeIcon.classList.add('button-filter-icon')
    const h = document.createElement('span')
    h.classList.add('h')
    const v = document.createElement('span')
    v.classList.add('v')

    closeIcon.appendChild(h)
    closeIcon.appendChild(v)

    chip.appendChild(closeIcon)

    return chip
  }

  const updateChips = () => {

    chipsContainer.innerHTML = ''

    if (familyButtonsActive) {
      let chip = createChip(forFamilyButtons[0].innerText)
      chip.addEventListener('click', e => {
        familyButtonsActive = false
        forFamilyButtons[0].classList.remove('active')
        recentlyChanged = true
        updateUrl()
        updateChips()
      })
      chipsContainer.appendChild(chip)
    }

    Object.values(allItems).forEach( item => {
      if (item.isActive) {
        const chip = createChip(item.element.innerText)
        chip.addEventListener('click', e => setItemActive(item.category, item.key))
        chipsContainer.appendChild(chip)
      }
    })
  }

  const updateUrl = () => {
      const url = new URL(window.location)

      if (recentlyChanged) {
        page = 1
      }

      // Clear all filter params
      url.searchParams.forEach( (value, key) => url.searchParams.delete(key) )

    console.log(familyButtonsActive)
      if (familyButtonsActive) {
        url.searchParams.set('family', '1')
      }

      Object.values(allItems).forEach( item => {
        if (item.isActive) {
          url.searchParams.set(item.category, item.key)
        }
      })

    url.searchParams.set('seite', page)

      window.history.pushState({}, '', url.toString())
      window.dispatchEvent(new CustomEvent('filter:change',{
          detail: {
            recentlyChanged: recentlyChanged,
            state: Object.fromEntries( url.searchParams.entries() )
          }
      }) )

    recentlyChanged = false
  }


  triggers.forEach(elm => elm.addEventListener('click', e => {
    page++
    updateUrl()
  }))


  updateChips()
})
